import {QUOTES} from './quotes.js'

const colors =  ["#DC143C","#00FF00","#20B2AA","#9400D3","#A0522D","#7B68EE"];
const BACKGROUNDS = [];

for (let i = 0; i <= QUOTES.length; i++){
    BACKGROUNDS.push(colors[random()]);
    if (BACKGROUNDS[i] === BACKGROUNDS[i-1]){ 
        BACKGROUNDS.splice(i,1);
        BACKGROUNDS.push(colors[random()])
    }
}

function random(){
    return Math.floor(Math.random()*colors.length)
}
export {BACKGROUNDS}

